import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import MyFavoriteProviders from "./MyFavoriteProviders";
import MyCareTeamProviders from "./MyCareTeamProviders";
import MyDirectScheduleProviders from "./MyDirectScheduleProviders";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import COVIDScreeningModal from "../common/COVIDScreeningModal";
import * as d from "../../reducers/domainReducer";
import { CovidScreeningModalSessionKeyInitial } from "../../constants/textConstants";

class MyProviders extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.MyProviders.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render()
    {
        const { showCOVID19Modal, hasMyChartLogin, currentMyChartUser, userName } = this.props;
        this.sessionKey = currentMyChartUser && currentMyChartUser.displayName && currentMyChartUser.eid ?
            userName + '_' + currentMyChartUser.displayName + '_' + currentMyChartUser.eid : userName;
        const shouldShowCovidModal = !Tools.getItemFromSessionStorage(CovidScreeningModalSessionKeyInitial + this.sessionKey) ? true : false;

        return (
            <div className="container-fluid body-content favorite-doctors-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">

                        <MyFavoriteProviders />
                        {showCOVID19Modal && hasMyChartLogin && shouldShowCovidModal ? <COVIDScreeningModal shouldShowCovidModal /> : null}

                        {/*
                          * Removed per Jason
                            <MyCareTeamProviders />
                        */}
                        {/*
                            window.serverData.data.enableDirectScheduling &&
                            <MyDirectScheduleProviders />
                        */}
                    </div>
                </div>
            </div>
        );

    }
};

const mapStateToProps = (state) => {
    return {
        showCOVID19Modal: state.session.serverData && state.session.serverData.showCOVID19Modal ? state.session.serverData.showCOVID19Modal : false,
        hasMyChartLogin: state.domain.hm,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        userName: state.domain.un
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyProviders));
